import { render } from "./ApprovedLiquidation.vue?vue&type=template&id=b95d2dfc"
import script from "./ApprovedLiquidation.vue?vue&type=script&lang=js"
export * from "./ApprovedLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__